/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const respiratoryQuestions = [
    {
        id: questionIds.DoYouSmoke,
        questionText: "Do you smoke?",
    },
    {
        id: questionIds.HowManySmokePerDay,
        questionText: "Please state how many per day",
    },
    {
        id: questionIds.ExSmoker,
        questionText: "Are you an ex-smoker?",
    },
    {
        id: questionIds.ExSmokerWhenQuitAndHowManySmokePerDay,
        questionText: "Please state when you quit and how many you used to smoke",
    },
    {
        id: questionIds.AnyMedicationAsthmaOtherRespiratoryConditions,
        questionText: "Do you take any medication for asthma or other respiratory conditions?",
    },
    {
        id: questionIds.AnyMedicationAsthmaOtherRespiratoryConditionsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DrinkAlcohol,
        questionText: "Do you drink alcohol?",
    },
    {
        id: questionIds.DrinkAlcoholNumberOfUnitsPerWeek,
        questionText: "Please state approx. units consumed per week",
    },
    {
        id: questionIds.Exercise,
        questionText: "Do you exercise?",
    },
    {
        id: questionIds.ExerciseHoursPerWeek,
        questionText: "Please state approx. hours per week",
    },
    {
        id: questionIds.CurrentlySufferingAsthma,
        questionText: "Asthma",
    },
    {
        id: questionIds.CurrentlySufferingAsthmaSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingAsthmaSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingAsthmaFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingBronchitis,
        questionText: "Bronchitis",
    },
    {
        id: questionIds.CurrentlySufferingBronchitisSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingBronchitisSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingBronchitisFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingTuberculosis,
        questionText: "Tuberculosis",
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingTuberculosisFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingDryCough,
        questionText: "Dry cough / cough phlegm",
    },
    {
        id: questionIds.CurrentlySufferingDryCoughSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingDryCoughSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingDryCoughFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingChestTightness,
        questionText: "Chest tightness",
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingChestTightnessFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyes,
        questionText: "Recurring soreness or watering of eyes",
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblems,
        questionText: "Work related breathing problems",
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingWorkRelatedBreatingProblemsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingCancer,
        questionText: "Cancer",
    },
    {
        id: questionIds.CurrentlySufferingCancerSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingCancerSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingCancerFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingChestInjury,
        questionText: "Chest injury or operation",
    },
    {
        id: questionIds.CurrentlySufferingChestInjurySymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingChestInjurySymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingChestInjuryFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingBreathlessness,
        questionText: "Breathlessness",
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingBreathlessnessFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingWheezing,
        questionText: "Wheezing",
    },
    {
        id: questionIds.CurrentlySufferingWheezingSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingWheezingSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingWheezingFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNose,
        questionText: "Recurring blocked or running nose",
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultOfWork,
        questionText: "Do you believe that you have experienced these symptoms as a result of your work?",
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultsOfHome,
        questionText: "Do you believe that you have experienced these symptoms as a result of something at home?",
    },
    {
        id: questionIds.CurrentlySufferingRecurringBlockedRunningNoseFurtherDetails,
        questionText: "Please provide details",
    }
];
